import { DocumentTypesEnum } from '../document-data/document-data.data';
import { Document } from '../document-data/document.model';
import { Billing } from '../document-data/sub-models/billing.model';
import { Toggles } from '../features-data/sub-models/toggles.model';
import { IRendererOptions } from '../renderer/renderer.interface';

export interface IBankTransferPayload {
  enabled: boolean;
}

export interface ICardPaymentsPayload {
  payments_enabled_by_user: boolean;
  country_code: string;
}

export interface IPaypalPayload {
  paypal_ec_enabled: boolean;
}

export interface IInvalidEmailConfirmDialogData {
  documentType: DocumentTypesEnum;
  documentId: string;
}

export interface IReceiptPreviewPayload {
  transaction_item: any;
  document: any;
  rendering_options: IRendererOptions;
}

export interface ISendReceiptPayload {
  document_id: string;
  transaction_id: string;
  rendering_options: IRendererOptions;
}

export interface ISendReceipt {
  documentBilling: Billing;
  documentId: string;
  documentType: DocumentTypesEnum;
  transactionId: string;
  renderingOptions: IRendererOptions;
}

export interface ISendReceiptPreview {
  transaction: IAddPaymentPayload;
  document: Document;
  renderingOptions: IRendererOptions;
  dialogType?: string;
}

export interface IAddPaymentPayload {
  amount: number;
  method_detail: string;
  description: string;
  datetime: string;
}

export interface IAddManualPayment {
  sendReceipt: boolean;
  renderingOptions: IRendererOptions;
  document: Document;
  addPayment: IAddPaymentPayload;
}

export interface ISendReceiptResponse {
  job_id: string;
}

export interface IRemindersPreview {
  reminder_days: number[];
}

export interface ITransactionHistoryUrlResponse {
  url: string;
}

export interface IMarkAsPaidData {
  paymentMethod: string;
  description: string;
  isSendReceipt: boolean;
  renderingOptions: IRendererOptions;
}

export enum TransactionActionsEnum {
  delete_transaction = 'delete_transaction',
  no_refund_transaction = 'no_refund_transaction',
  refund_transaction = 'refund_transaction',
  unmatch_transaction = 'unmatch_transaction',
  see_transaction_in_dashboard = 'see_transaction_in_dashboard',
  send_receipt = 'send_receipt',
}

export enum AchDebitStatusEnum {
  enabled = 'enabled',
  disabled = 'disabled',
  ineligible = 'ineligible',
  underwriting_required = 'underwriting_required',
}

export enum CardPaymentsStatusEnum {
  enabled = 'enabled',
  disabled = 'disabled',
  ineligible = 'ineligible',
  underwriting_required = 'underwriting_required',
}

export enum PaymentErrorsEnum {
  transaction_refunded = 3000,
  unsupported_country_or_currency = 3011,
  underwriting_required = 3012,
  transaction_unmatched = 400,
}

export interface PayPalTransactionItem {
  id: string;
  type: string;
  created_date: string;
  amount: number;
  currency: string;
  document?: {
    document_id: string;
    document_type: string;
    document_number: string;
    client_name: string;
    client_id: string;
  };
  statement?: {
    statement_view_id: string;
  };
}

export const STRIPE_UNDERWRITING_KEY = 'stripe_underwriting_key';

export const PAYMENT_REMINDER_THREE_BEFORE = -3;

export const PAYMENT_REMINDER_ON_DUE = 0;

export const PAYMENT_REMINDER_THREE_AFTER = 3;

export const PAYMENT_REMINDER_SEVEN_AFTER = 7;

export function getDefaultReminders(toggles: Toggles): number[] {
  return toggles.isAllAccess(Toggles.KEYS.ALL_PAYMENT_REMINDER_OPTIONS_ENABLED)
    ? [
        PAYMENT_REMINDER_THREE_BEFORE,
        PAYMENT_REMINDER_ON_DUE,
        PAYMENT_REMINDER_THREE_AFTER,
        PAYMENT_REMINDER_SEVEN_AFTER,
      ]
    : [PAYMENT_REMINDER_THREE_BEFORE, PAYMENT_REMINDER_THREE_AFTER];
}

export const PAYPAL_DASHBOARD_LINK = 'https://www.paypal.com/mep/dashboard';
